import { onError } from "apollo-link-error";
import { Observable } from "apollo-link";
import { msalInstance, getToken } from "../msalConfig";
import { environment } from "../../environments/environment";

export const onLogout = onError(({ forward, operation, graphQLErrors, networkError }) => {
  if (Array.isArray(graphQLErrors)) {
    graphQLErrors.map(({ message, locations, path }) =>
      console.error(
        `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(
          locations
        )}, Path: ${path}`
      )
    );
  }

  // eslint-disable-next-line no-prototype-builtins
  if (networkError && networkError.hasOwnProperty("bodyText")) {
    networkError.message = (networkError as any).bodyText;
  }

  const isUnauthorized =
    (graphQLErrors?.map((x) => x) || []).any((x) => x.message === "Unauthorized") ||
    (networkError && (networkError as any).statusCode === 401);

  if (!isUnauthorized) {
    return;
  }

  // Prevent infinite retry loops
  const context = operation.getContext();
  if (context.__authRetry) {
    return;
  }
  operation.setContext({ __authRetry: true });

  return new Observable((observer) => {
    getToken()
      .then((token) => {
        if (token) {
          // Token refreshed successfully — retry the operation
          forward(operation).subscribe(observer);
        } else {
          // No token obtained — redirect to login
          msalInstance
            .loginRedirect({
              scopes: [`${environment.azureClientId}/.default`]
            })
            .catch((error) => {
              if (error?.errorCode !== "interaction_in_progress") {
                console.error("Login redirect error:", error);
              }
            });
          // Don't complete or error the observer — page is redirecting
        }
      })
      .catch(() => {
        // Token refresh threw — redirect to login
        msalInstance
          .loginRedirect({
            scopes: [`${environment.azureClientId}/.default`]
          })
          .catch((error) => {
            if (error?.errorCode !== "interaction_in_progress") {
              console.error("Login redirect error:", error);
            }
          });
      });
  });
});
